export interface DeleteSynonymGroupRequest {
  group: number
  revision: number
}

export function DeleteSynonymGroupRequestToJSON(
  value: DeleteSynonymGroupRequest
): any {
  return {
    group: value.group !== 0 ? value.group : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
